import React from "react";
import { Controller } from "react-hook-form";
import { FontEnum } from "../../utils/enums/FontEnum";

const ControllerTextInput = ({
  name,
  control,
  defaultValue,
  placeholder,
  disabled = false,
  onChange,
  width = 254,
  styleForInput = {}
}) => {

  const getStyle = () => {
    return {
      ...styles.inputStyle,
      width,
      ...styleForInput, 
    };
  };

  return (
    <Controller
      name={name}
      defaultValue={defaultValue || ""}
      control={control}
      render={({ field, fieldState }) => (
        <input
          {...field}
          id={name}
          style={getStyle()}
          placeholder={placeholder ?? ""}
          disabled={disabled}
          onChange={(e) => {
            field.onChange(e);
            if (onChange) {
              onChange(e);
            }
          }}
        />
      )}
    />
  );
};

export default ControllerTextInput;

const styles = {
  inputStyle: {
    minWidth: "250px",
    height: "56px",
    backgroundColor: 'transparent',
    border: "1px solid #0000003b",
    borderRadius: 6,
    paddingInline: 12,
    fontFamily: FontEnum.TITILIUM_WEB,
    color: '#fff',
    fontSize: 16,
  }
};
